import React, { useEffect, useState } from 'react';

import { useSelector, useDispatch } from 'react-redux';
import { InputMask } from 'primereact/inputmask';

import '../../static/css/main.css'
import '../../static/fonts/stylesheet.css'
import icon_s3_1 from '../../static/img/icon-s3-1.svg'
import arrow from '../../static/img/Arrow_dropdown-gray.svg'
import heart from "../../static/img/heart.svg"
import icon_heart from "../../static/img/icon-heart-gray.svg"
import icon_home from "../../static/img/icon-home-gray.svg"
import icon_s3_2 from "../../static/img/icon-s3-2.svg"
import { PoliceCard } from './buy/policeCard';
import { selectIdPoliceL, selectIdPoliceP, selectIndexLifeMin, selectIndexPropertyMin, selectInsuranceCompanyLife, selectInsuranceCompanyProperty, selectLinkPayPari, selectLinkRedirectPary, selectListCompaniesLife, selectListCompaniesProperty, selectNumPolicyPari, selectPhone, selectPolicyIdLife, selectPolicyIdProp, selectShowChangeField, selectSumFinalL, selectSumFinalP, selectWaitFinalCalc, setLinkPayPari, setPhone } from './calcSlice';
import { selectLifeOption, selectPropertyOption } from '../precalc/precalcSlice';
import { PoliceCardOneB } from './buy/policeCardOneB';
import { getStatusPayPari } from './calcApi';
import { printPari } from '../personal/personapi'
import NextBtn from './nextBtn';
import { MAIN_ROUTE } from '../../static/vars';


export function StepBuy() {
    const dispath = useDispatch()

    const sumFinalP = useSelector(selectSumFinalP)
    const sumFinalL = useSelector(selectSumFinalL)

    const list_companies_property = useSelector(selectListCompaniesProperty)
    const list_companies_life = useSelector(selectListCompaniesLife)
    const index_property_min = useSelector(selectIndexPropertyMin)
    const index_life_min = useSelector(selectIndexLifeMin)

    const waitFinalCalc = useSelector(selectWaitFinalCalc)

    const insuranceCompanyProperty = useSelector(selectInsuranceCompanyProperty)
    const insuranceCompanyLife = useSelector(selectInsuranceCompanyLife)
    const lifeOption = useSelector(selectLifeOption)
    const propertyOption = useSelector(selectPropertyOption)

    const isTwoPoliciesOnePari = lifeOption && propertyOption && (
        insuranceCompanyProperty === 'pari' || insuranceCompanyLife === 'pari'
    )

    const isTwoPolices = lifeOption && propertyOption


    const [isBuy, setIsBuy] = useState(false);

    const [showPayPariWindow, setShowPayPariWindow] = useState(false);

    const [waitPay, setWaitPay] = useState(false);
    const [waitPayPari, setWaitPayPari] = useState(false);
    const [isPayPari, setIsPayPari] = useState(false);
    const [isPay, setIsPay] = useState(false);
    const showChangeField = useSelector(selectShowChangeField);


    const linkPayPari = useSelector(selectLinkPayPari)
    const linkRedirectPari = useSelector(selectLinkRedirectPary)
    const idPoliceP = useSelector(selectIdPoliceP)
    const idPoliceL = useSelector(selectIdPoliceL)

    const policyIdProp = useSelector(selectPolicyIdProp)
    const policyIdLife = useSelector(selectPolicyIdLife)

    const phone = useSelector(selectPhone)

    const num_policy_pari = useSelector(selectNumPolicyPari)

    let payInterval;
    let payIntervalPari;

    const handleChangePhone = (e) => {
        dispath(setPhone(e.target.value))
    }

    const handleGetPdfPolicy = (isn, path, company_id) => {
        console.log('handleGetPdfPolicy ', isn, path, company_id)
        var newWin = window.open("about:_blank", "hello", "width=1000,height=800");
        // console.log('path', path)
        if (path === 'z') {
            // console.log(path, isn)
            newWin.document.write(`
                <embed src="https://c61437.na4u.ru/static/policies_zetta/` + isn + `.pdf" width="1000" height="800" 
                type="application/pdf"/>
            `);
        }
        else if (path === 'p' || company_id === 3) {
            printPari({ isn: isn }, (data) => {
                console.log('printPari', data)

                var newWin = window.open("about:_blank", "hello", "width=1000,height=800");
                newWin.document.write(`
                    <embed src="https://c61437.na4u.ru/static/policies_pari/` + data.res + `.pdf" width="1000" height="800" 
                    type="application/pdf"/>
                `);
            })
        }

        else if (company_id === 4) {
            newWin.document.write(`
                <embed src="https://c61437.na4u.ru/static/policies_vsc/` + path + `.pdf" width="1000" height="800" 
                type="application/pdf"/>
            `);
        }
        else if (path !== '') {
            console.log('abs')
            newWin.document.write(`
                <embed src="https://c61437.na4u.ru/static/policies/` + path + `.pdf" width="1000" height="800" 
                type="application/pdf"/>
            `);
        }


    }

    const handleDownloadProperty = () => {
        window.ym(90426649,'reachGoal','load')
        console.log('handleDownloadProperty')
        getStatusPayPari({ num_policy_pari: idPoliceP }, (data) => {
            console.log('getStatusPay', data)
            if (data.res) {
                console.log('stop interval')
                setWaitPay(false)
                setIsPay(true)
                clearInterval(payInterval)
                payInterval = null
                handleGetPdfPolicy(idPoliceP, data.path, 1)
            }
        })
    }

    const handleDownloadLife = () => {
        window.ym(90426649,'reachGoal','load')
        getStatusPayPari({ num_policy_pari: idPoliceL }, (data) => {
            console.log('getStatusPay Life', data)
            if (data.res) {
                console.log('stop interval')
                setWaitPay(false)
                setIsPay(true)
                clearInterval(payInterval)
                payInterval = null
                handleGetPdfPolicy(idPoliceL, data.path, 1)
            }
        })
    }

    const handleDownloadPari = () => {
        window.ym(90426649,'reachGoal','load')
        console.log('handleDownloadPari', num_policy_pari)
        getStatusPayPari({ num_policy_pari: num_policy_pari }, (data) => {
            console.log('getStatusPay', data)
            if (data.res) {
                console.log('stop interval')
                setWaitPay(false)
                setIsPay(true)
                clearInterval(payInterval)
                payInterval = null
                handleGetPdfPolicy(num_policy_pari, data.path, 1)
            }
        })
    }

    const handleGetStatusPay = () => {
        getStatusPayPari({ num_policy_pari: idPoliceP }, (data) => {
            console.log('getStatusPay', data)
            if (data.res) {
                window.ym(90426649,'reachGoal','successpay')
                console.log('stop interval')
                setWaitPay(false)
                setIsPay(true)
                clearInterval(payInterval)
                payInterval = null
            }
        })

    }

    const handleGetStatusPayPari = () => {

        getStatusPayPari({ num_policy_pari: num_policy_pari }, (data) => {
            console.log('getStatusPayPari', data)
            if (data.res) {
                window.ym(90426649,'reachGoal','successpay')
                console.log('stop interval')
                setWaitPayPari(false)
                setIsPayPari(true)
                clearInterval(payIntervalPari)
                payIntervalPari = null
            }
        })

    }

    const handlePayDomStrah = () => {
        window.ym(90426649,'reachGoal','kypit_clck')
        setIsBuy(true)
        clearInterval(payInterval)
        // const link = MAIN_ROUTE + `/pay/${((propertyOption && insuranceCompanyProperty !== 'pari') ? idPoliceP : '0') || '0'}/${((lifeOption && insuranceCompanyLife !== 'pari') ? idPoliceL : '0') || '0'}/${((propertyOption && insuranceCompanyProperty !== 'pari') ? sumFinalP : '0') || '0'}/${((lifeOption && insuranceCompanyLife !== 'pari') ? sumFinalL : '0') || '0'}`
        const link = MAIN_ROUTE + `/pay/${policyIdProp}/${policyIdLife}/${((propertyOption && insuranceCompanyProperty !== 'pari') ? sumFinalP : '0') || '0'}/${((lifeOption && insuranceCompanyLife !== 'pari') ? sumFinalL : '0') || '0'}`
        console.log(link)
        dispath(setLinkPayPari(link))
        setShowPayPariWindow(true)
        if (!payInterval) payInterval = setInterval(handleGetStatusPay, 5000)
    }

    const handlePayPari = () => {
        window.ym(90426649,'reachGoal','kypit_clck')
        dispath(setLinkPayPari(linkRedirectPari))
        console.log('handlePayPari')
        clearInterval(payIntervalPari)
        setShowPayPariWindow(true)
        setWaitPayPari(true)



        if (!payIntervalPari) payIntervalPari = setInterval(handleGetStatusPayPari, 3000)
    }

    useEffect(() => {
        return () => {
          console.log("cleaned up");
          clearInterval(payInterval)
          clearInterval(payIntervalPari)
        };
      }, []);

    return (
        <>
            <div class="section-calculator-tab-body calculator-tab-body-4 ">
                <div class="calculator-tab-body-blok calculator-tab-body-blok-1">
                    <p class="calculator-tab-body-blok-title calculator-tab-body-blok-title-301">Ваш полис
                    </p>
                    <div class="tab-body-blok-contant-401">
                        {showChangeField &&
                            <div class="tab-body-blok-contant-401-up">
                                <div class="tab-body-blok-info-403">
                                    <p
                                        class="tab-body-blok-info-animation-text tab-body-blok-info-animation-text-2 tab-body-blok-info-element-400-text">
                                        Обязательное требование данных страховых компаний— оплата строго по
                                        очереди.
                                        После оплаты данные придут на почту указанную ранее.</p>
                                </div>
                                <div class="tab-body-blok-info-400">
                                    <div class="tab-body-blok-info-element tab-body-blok-info-element-400">
                                        <div class="tab-body-blok-info-element-vnutr">
                                            <label class="section-two-banks-text-2" for="pet-select">Мобильный
                                                телефон</label>
                                            <InputMask mask="+7(999) 999-9999"
                                                placeholder="+7(___) ___-____"
                                                className="pole pole-step-2 mask-phone "
                                                value={phone}
                                                onChange={handleChangePhone}
                                            />
                                        </div>
                                    </div>
                                    <p
                                        class="tab-body-blok-info-animation-text tab-body-blok-info-animation-text-2 tab-body-blok-info-element-400-text">
                                        Страховая компания не принимает текущий номер телефона. Пожалуйста,
                                        укажите
                                        новый номер или оформите заявку с помощью нашего менеджера.</p>
                                    {/* <div class="button button-1 button-novostroiki-1 button-step-2 button-step-400"
                                    >
                                        Оформить
                                    </div> */}
                                    <NextBtn
                                        text={'Изменить'}
                                        checkOne={true}
                                        checkTwo={true}
                                        checkThree={true}
                                        checkFour={true}
                                        setShowAlertForUser={() => { }}
                                        check={false}

                                    />
                                </div>
                            </div>
                        }
                        {waitFinalCalc &&
                            <div class="blok-info-animation">
                                <div class="circle-box" id="circle-box">
                                    <div class="circle circle-1 slideInDown wow"></div>
                                    <div class="circle circle-2 slideInDown wow"></div>
                                    <div class="circle circle-3 slideInDown wow"></div>
                                </div>
                            </div>
                        }

                        {!waitFinalCalc && !isTwoPoliciesOnePari && !isTwoPolices && propertyOption &&
                            <PoliceCard insurance={list_companies_property[index_property_min]?.company}
                                sum={sumFinalP}
                                isBuy={isBuy}
                                setIsBuy={setIsBuy}
                                isPay={isPay}
                                selfManager={idPoliceP === 'manager'}
                                otherManager={idPoliceL === 'manager'}
                                handlePayDomStrah={handlePayDomStrah}
                                handleDownload={handleDownloadProperty}
                                type={'Недвижимость'}
                            />
                        }

                        {!waitFinalCalc && !isTwoPoliciesOnePari && !isTwoPolices && lifeOption &&
                            <PoliceCard insurance={list_companies_life[index_life_min]?.company} sum={sumFinalL} 
                                type={'Жизнь'}
                            />
                        }

                        {!waitFinalCalc && !isTwoPoliciesOnePari && isTwoPolices &&
                            <>
                                <PoliceCard insurance={list_companies_property[index_property_min]?.company}
                                    sum={sumFinalP}
                                    isBuy={isBuy}
                                    setIsBuy={setIsBuy}
                                    isPay={isPay}
                                    selfManager={idPoliceP === 'manager'}
                                    otherManager={idPoliceL === 'manager'}
                                    handlePayDomStrah={handlePayDomStrah}
                                    handleDownload={handleDownloadProperty}
                                    type={'Недвижимость'}
                                />
                                <div style={{ marginTop: '30px', marginBottom: '15px', borderTop: '1px solid black' }}></div>
                                <PoliceCard
                                    insurance={list_companies_life[index_life_min]?.company}
                                    sum={sumFinalL}
                                    isBuy={isBuy}
                                    setIsBuy={setIsBuy}
                                    isPay={isPay}
                                    selfManager={idPoliceL === 'manager'}
                                    otherManager={idPoliceP === 'manager'}
                                    handlePayDomStrah={handlePayDomStrah}
                                    handleDownload={handleDownloadLife}
                                    type={'Жизнь'}
                                />

                            </>
                        }

                        {!waitFinalCalc && isTwoPoliciesOnePari &&
                            <>
                                <PoliceCardOneB
                                    setShowPayPariWindow={setShowPayPariWindow}
                                    insurance={list_companies_property[index_property_min]?.company}
                                    sum={sumFinalP}
                                    waitPay={list_companies_property[index_property_min]?.company === 'ПАРИ' ? waitPayPari : waitPay}
                                    setWaitPay={list_companies_property[index_property_min]?.company === 'ПАРИ' ? setWaitPayPari : setWaitPay}
                                    handlePay={list_companies_property[index_property_min]?.company === 'ПАРИ' ? handlePayPari : handlePayDomStrah}
                                    handleDownload={list_companies_property[index_property_min]?.company === 'ПАРИ' ? handleDownloadPari : handleDownloadProperty}
                                    type={'Недвижимость'}
                                    selfManager={idPoliceP === 'manager'}
                                />
                                <PoliceCardOneB
                                    setShowPayPariWindow={setShowPayPariWindow}
                                    insurance={list_companies_life[index_life_min]?.company}
                                    sum={sumFinalL}
                                    waitPay={list_companies_life[index_life_min]?.company === 'ПАРИ' ? waitPayPari : waitPay}
                                    setWaitPay={list_companies_life[index_life_min]?.company === 'ПАРИ' ? setWaitPayPari : setWaitPay}
                                    handlePay={list_companies_life[index_life_min]?.company === 'ПАРИ' ? handlePayPari : handlePayDomStrah}
                                    handleDownload={list_companies_life[index_life_min]?.company === 'ПАРИ' ? handleDownloadPari : handleDownloadLife}
                                    type={'Жизнь'}
                                    selfManager={idPoliceL === 'manager'}
                                />
                            </>
                        }


                        {!isTwoPoliciesOnePari && !waitFinalCalc && !isTwoPolices && propertyOption &&
                            (idPoliceP !== 'manager' && idPoliceL !== 'manager') &&
                            <div class="button button-1 button-novostroiki-1 button-step-401"
                                onClick={isPay ? handleDownloadProperty : handlePayDomStrah}
                            >
                                {
                                    isPay ? 'Скачать' :
                                        isBuy ? 'Ожидание' : 'Перейти к оплате'
                                }
                            </div>
                        }

                        {!isTwoPoliciesOnePari && !waitFinalCalc && !isTwoPolices && lifeOption &&
                            <div class="button button-1 button-novostroiki-1 button-step-401"
                                onClick={isPay ? handleDownloadLife : handlePayDomStrah}
                            >
                                {
                                    isPay ? 'Скачать' :
                                        isBuy ? 'Ожидание' : 'Перейти к оплате'
                                }
                            </div>
                        }

                        {!isTwoPoliciesOnePari && !waitFinalCalc && isTwoPolices && !isPay &&
                            (idPoliceL !== 'manager' && idPoliceP !== 'manager') &&
                            <>
                                <div class="button button-1 button-novostroiki-1 button-step-401"
                                    onClick={isPay ? handleDownloadProperty : handlePayDomStrah}
                                >
                                    {
                                        isBuy ? 'Ожидание' : 'Перейти к оплате'
                                    }
                                </div>
                            </>
                        }

                        {isBuy && (idPoliceL !== 'manager' && idPoliceP !== 'manager') && !isTwoPoliciesOnePari &&
                            <div onClick={() => setIsBuy(false)}>
                                <p class="tab-body-4-dopinfo-link" id="tab-body-4-dopinfo-link-6">
                                    Оплатить снова
                                </p>
                            </div>
                        }

                        {
                            showPayPariWindow &&
                            <div className='cntr_iframe'>
                                <div className='btn btn-secondary' onClick={() => setShowPayPariWindow(false)}>Закрыть</div>
                                <iframe title='pay' className='iframe_pay' src={linkPayPari}>

                                </iframe>
                            </div>
                        }











                        {/* <div class="tab-body-blok-info-401" id="tab-body-blok-info-401-2">
                            <div class="tab-body-blok-info-401-element">
                                <img src={icon_s3_1} alt="" />
                                <p class="blok-info-401-element-text">Альфа страхование</p>
                            </div>
                            <div class="tab-body-4-blok-price">
                                <div class="tab-body-4-price-1">
                                    12 800
                                </div>
                                <div class="tab-body-4-price-2">
                                    -10%
                                </div>
                                <div class="tab-body-4-price-3">
                                    11 400 ₽
                                </div>
                            </div>
                            <div class="tab-body-4-dopinfo-blok-link">
                                <p class="tab-body-4-dopinfo-link" id="tab-body-4-dopinfo-link-2">
                                    Данные полиса
                                    <img class="icon-down-arrow icon-down-arrow-401"
                                        src={arrow} alt="arrow icon" />
                                </p>
                            </div>
                            <div class="tab-body-4-blok-dopinfo tab-body-4-blok-dopinfo-2"
                                id="tab-body-4-blok-dopinfo-2">
                                <img class="icon-home-gray" src={icon_home} alt="home" />
                                <p class="tab-body-4-blok-dopinfo-text tab-body-4-blok-dopinfo-text-3">
                                    Будет застраховано: Недвижимость<br />
                                    Банк: ВТБ<br />
                                    Страховая компания: Альфа абсолют<br />
                                    Остаток кредита: 3 000 000<br />
                                    Кредитный договор: 3719798<br />
                                    Дата заключения: 02.02.2001<br />
                                    Дата окончания: 02.02.2031<br />
                                    Дата начала действия полиса: 02.02.2022<br />
                                    Дата окончания действия полиса: 02.02.2031<br />
                                    Фамилия: Иванов<br />
                                    Имя: Иван<br />
                                    Отчетство: Иванович<br />
                                    Дата рождения: 01.01.1990<br />
                                    Документ: Паспорт<br />
                                    Серия/номер: 7839<br />
                                    573987<br />
                                    Код подразделения: 422<br />
                                    Кем выдан: ОВД 1<br />
                                    Адрес регистрации: Москва, Ленина 1, кв.33<br />
                                    Пол: Мужской<br />
                                    Адрес страхуемого объекта: Москва, Ленина 1, кв.33<br />
                                    Год постройки: 1980<br />
                                    Этажность: 7</p>
                            </div>
                        </div>

                        <div class="tab-body-blok-info-401" id="tab-body-blok-info-401-3">
                            <div class="tab-body-blok-info-401-element">
                                <img src={icon_s3_2} alt="" />
                                <p class="blok-info-401-element-text">Сам страхование</p>
                            </div>
                            <div class="tab-body-4-blok-price">
                                <div class="tab-body-4-price-1">
                                    12 800
                                </div>
                                <div class="tab-body-4-price-2">
                                    -10%
                                </div>
                                <div class="tab-body-4-price-3">
                                    11 400 ₽
                                </div>
                            </div>
                            <div class="tab-body-4-dopinfo-blok-link">
                                <p class="tab-body-4-dopinfo-link" id="tab-body-4-dopinfo-link-3">Данные
                                    полиса
                                    <img class="icon-down-arrow icon-down-arrow-401"
                                        src={arrow} alt="arrow icon" />
                                </p>
                            </div>
                            <div class="tab-body-4-blok-dopinfo tab-body-4-blok-dopinfo-3"
                                id="tab-body-4-blok-dopinfo-3">
                                <img class="icon-home-gray" src={icon_heart} alt="home" />
                                <p class="tab-body-4-blok-dopinfo-text tab-body-4-blok-dopinfo-text-3">
                                    Будет застраховано: Недвижимость<br />
                                    Банк: ВТБ<br />
                                    Страховая компания: Альфа абсолют<br />
                                    Остаток кредита: 3 000 000<br />
                                    Кредитный договор: 3719798<br />
                                    Дата заключения: 02.02.2001<br />
                                    Дата окончания: 02.02.2031<br />
                                    Дата начала действия полиса: 02.02.2022<br />
                                    Дата окончания действия полиса: 02.02.2031<br />
                                    Фамилия: Иванов<br />
                                    Имя: Иван<br />
                                    Отчетство: Иванович<br />
                                    Дата рождения: 01.01.1990<br />
                                    Документ: Паспорт<br />
                                    Серия/номер: 7839<br />
                                    573987<br />
                                    Код подразделения: 422<br />
                                    Кем выдан: ОВД 1<br />
                                    Адрес регистрации: Москва, Ленина 1, кв.33<br />
                                    Пол: Мужской<br />
                                    Адрес страхуемого объекта: Москва, Ленина 1, кв.33<br />
                                    Год постройки: 1980<br />
                                    Этажность: 7</p>
                            </div>
                        </div>

                        <div class="tab-body-blok-info-401" id="tab-body-blok-info-401-4">
                            <div class="tab-body-blok-info-401-element">
                                <img src={icon_s3_1} alt="" />
                                <p class="blok-info-401-element-text">Альфа страхование</p>
                            </div>
                            <div class="tab-body-blok-info-401-element tab-body-blok-info-401-element-2">
                                <img src={heart} alt="" />
                                <p class="blok-info-401-element-text">Сом страх</p>
                            </div>
                            <div class="tab-body-4-blok-price">
                                <div class="tab-body-4-price-1">
                                    12 800
                                </div>
                                <div class="tab-body-4-price-2">
                                    -10%
                                </div>
                                <div class="tab-body-4-price-3">
                                    11 400 ₽
                                </div>
                            </div>
                            <div class="tab-body-4-dopinfo-blok-link">
                                <p class="tab-body-4-dopinfo-link" id="tab-body-4-dopinfo-link-4">Данные
                                    полиса
                                    <img class="icon-down-arrow icon-down-arrow-401"
                                        src={arrow} alt="arrow icon" />
                                </p>
                            </div>
                            <div class="tab-body-4-blok-dopinfo tab-body-4-blok-dopinfo-1"
                                id="tab-body-4-blok-dopinfo-4">
                                <div class="tab-body-4-blok-dopinfo-col">
                                    <img class="icon-home-gray" src={icon_home} alt="home" />
                                    <p class="tab-body-4-blok-dopinfo-text tab-body-4-blok-dopinfo-text-1">
                                        Страхование конструктивных
                                        элементов недвижимости (крыша,
                                        окна, лестницы, стены, перекрытия, перегородки).<br /><br />
                                        Риски в соответствии с требованием банка.<br /><br />
                                        Пожар, взрыв, нанесение вреда в результате стихийных бедствий,
                                        постороннее воздействие (падение деревьев и прочее).</p>
                                </div>
                                <div class="tab-body-4-blok-dopinfo-col">
                                    <img class="icon-home-gray" src={icon_heart} alt="home" />
                                    <p class="tab-body-4-blok-dopinfo-text tab-body-4-blok-dopinfo-text-2">
                                        Страхование от несчастных
                                        случаев и болезней.<br /><br />
                                        Риски в соответствии с требованием банка.<br /><br />
                                        Установление инвалидности 1–2 группы в результате несчастного случая
                                        или болезни.<br /><br />
                                        Смерть в результате несчастного случая или болезни.</p>
                                </div>
                            </div>
                            <a class="button button-1 button-novostroiki-1 button-step-4000"
                                href="#section-calculator">Перейти к оплате</a>
                            <a class="button button-1 button-novostroiki-1 button-step-4000 button-step-4000-active"
                                href="calculator-finish.html">Оплачено</a>
                        </div>

                        <div class="tab-body-blok-info-401" id="tab-body-blok-info-401-5">
                            <div class="tab-body-blok-info-401-element">
                                <img src={icon_s3_1} alt="" />
                                <p class="blok-info-401-element-text">Альфа страхование</p>
                            </div>
                            <div class="tab-body-4-blok-price">
                                <div class="tab-body-4-price-1">
                                    12 800
                                </div>
                                <div class="tab-body-4-price-2">
                                    -10%
                                </div>
                                <div class="tab-body-4-price-3">
                                    11 400 ₽
                                </div>
                            </div>
                            <div class="tab-body-4-dopinfo-blok-link">
                                <p class="tab-body-4-dopinfo-link" id="tab-body-4-dopinfo-link-5">Данные
                                    полиса
                                    <img class="icon-down-arrow icon-down-arrow-401"
                                        src={arrow} alt="arrow icon" />
                                </p>
                            </div>
                            <div class="tab-body-4-blok-dopinfo tab-body-4-blok-dopinfo-5"
                                id="tab-body-4-blok-dopinfo-5">
                                <img class="icon-home-gray" src={icon_home} alt="home" />
                                <p class="tab-body-4-blok-dopinfo-text tab-body-4-blok-dopinfo-text-3">
                                    Будет застраховано: Недвижимость<br />
                                    Банк: ВТБ<br />
                                    Страховая компания: Альфа абсолют<br />
                                    Остаток кредита: 3 000 000<br />
                                    Кредитный договор: 3719798<br />
                                    Дата заключения: 02.02.2001<br />
                                    Дата окончания: 02.02.2031<br />
                                    Дата начала действия полиса: 02.02.2022<br />
                                    Дата окончания действия полиса: 02.02.2031<br />
                                    Фамилия: Иванов<br />
                                    Имя: Иван<br />
                                    Отчетство: Иванович<br />
                                    Дата рождения: 01.01.1990<br />
                                    Документ: Паспорт<br />
                                    Серия/номер: 7839<br />
                                    573987<br />
                                    Код подразделения: 422<br />
                                    Кем выдан: ОВД 1<br />
                                    Адрес регистрации: Москва, Ленина 1, кв.33<br />
                                    Пол: Мужской<br />
                                    Адрес страхуемого объекта: Москва, Ленина 1, кв.33<br />
                                    Год постройки: 1980<br />
                                    Этажность: 7</p>
                            </div>
                            <a class="button button-1 button-novostroiki-1 button-step-4001"
                                href="#section-calculator">Перейти к оплате</a>
                            <a class="button button-1 button-novostroiki-1 button-step-4001 button-step-4001-active"
                                href="calculator-finish.html">Оплачено</a>
                        </div>

                        <div class="tab-body-blok-info-401" id="tab-body-blok-info-401-6">
                            <div class="tab-body-blok-info-401-element">
                                <img src={icon_s3_2} alt="" />
                                <p class="blok-info-401-element-text">Сам страхование</p>
                            </div>
                            <div class="tab-body-4-blok-price">
                                <div class="tab-body-4-price-1">
                                    12 800
                                </div>
                                <div class="tab-body-4-price-2">
                                    -10%
                                </div>
                                <div class="tab-body-4-price-3">
                                    11 400 ₽
                                </div>
                            </div>
                            <div class="tab-body-4-dopinfo-blok-link">
                                <p class="tab-body-4-dopinfo-link" id="tab-body-4-dopinfo-link-6">Данные
                                    полиса
                                    <img class="icon-down-arrow icon-down-arrow-401"
                                        src={arrow} alt="arrow icon" />
                                </p>
                            </div>
                            <div class="tab-body-4-blok-dopinfo tab-body-4-blok-dopinfo-6"
                                id="tab-body-4-blok-dopinfo-6">
                                <img class="icon-home-gray" src={icon_heart} alt="home" />
                                <p class="tab-body-4-blok-dopinfo-text tab-body-4-blok-dopinfo-text-3">
                                    Будет застраховано: Недвижимость<br />
                                    Банк: ВТБ<br />
                                    Страховая компания: Альфа абсолют<br />
                                    Остаток кредита: 3 000 000<br />
                                    Кредитный договор: 3719798<br />
                                    Дата заключения: 02.02.2001<br />
                                    Дата окончания: 02.02.2031<br />
                                    Дата начала действия полиса: 02.02.2022<br />
                                    Дата окончания действия полиса: 02.02.2031<br />
                                    Фамилия: Иванов<br />
                                    Имя: Иван<br />
                                    Отчетство: Иванович<br />
                                    Дата рождения: 01.01.1990<br />
                                    Документ: Паспорт<br />
                                    Серия/номер: 7839<br />
                                    573987<br />
                                    Код подразделения: 422<br />
                                    Кем выдан: ОВД 1<br />
                                    Адрес регистрации: Москва, Ленина 1, кв.33<br />
                                    Пол: Мужской<br />
                                    Адрес страхуемого объекта: Москва, Ленина 1, кв.33<br />
                                    Год постройки: 1980<br />
                                    Этажность: 7</p>
                            </div>
                            <a class="button button-1 button-novostroiki-1 button-step-4002"
                                href="#section-calculator">Перейти к оплате</a>
                            <a class="button button-1 button-novostroiki-1 button-step-4002 button-step-4002-active"
                                href="calculator-finish.html">Оплачено</a>
                        </div> */}
                    </div>
                </div>
            </div>
        </>
    );
}



